import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import MoodSelector from '../components/MoodSelector';
import RecommendationList from '../components/RecommendationList';
import SEOSection from '../components/SEOSection';
import FAQSection from '../components/FAQSection';
import InternalLinks from '../components/InternalLinks';
import SEO from '../components/SEO';
import { getRecommendations, getMoodLabel } from '../utils/getRecommendations';
import { HOMEPAGE_META } from '../utils/seo';

function Home() {
  const [selectedMood, setSelectedMood] = useState(null);
  const navigate = useNavigate();
  const moodSectionRef = useRef(null);

  const handleMoodSelect = (mood) => {
    setSelectedMood(mood);
    localStorage.setItem('lastMood', mood);
  };

  const handleCtaClick = () => {
    moodSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleViewRecommendations = () => {
    if (selectedMood) {
      navigate(`/recommendation/${selectedMood}`);
    }
  };

  const recommendations = selectedMood ? getRecommendations(selectedMood) : [];

  return (
    <div>
      <SEO title={HOMEPAGE_META.title} description={HOMEPAGE_META.description} />
      <Hero onCtaClick={handleCtaClick} />
      
      <div ref={moodSectionRef}>
        <MoodSelector onSelect={handleMoodSelect} selectedMood={selectedMood} />
      </div>

      {selectedMood && (
        <section className="py-8">
          <div className="bg-white rounded-xl shadow-sm border p-6">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                {getMoodLabel(selectedMood)}
              </h2>
              <p className="text-gray-600">
                Here are a few foods that might fit how you feel right now.
              </p>
            </div>
            <RecommendationList recommendations={recommendations} />
            <div className="mt-6 text-center">
              <button
                onClick={handleViewRecommendations}
                className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition"
              >
                View Full Recommendations
              </button>
            </div>
          </div>
        </section>
      )}

      <SEOSection />
      
      <section className="py-8 text-center">
        <button
          onClick={handleCtaClick}
          className="bg-black text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition shadow-sm"
        >
          Choose Your Mood
        </button>
      </section>

      <FAQSection />
      
      <InternalLinks />
    </div>
  );
}

export default Home;
